import React from 'react';
import { useIntl } from 'react-intl-next';
import { Text } from '@atlaskit/primitives/compiled';
/**
 * Formats an i18n string that contains partial text that should be shown in bold.
 * Message must be wrapped in strong tags. `The message <strong>is bold</strong>.`
 */
export var FormattedMessageBold = function FormattedMessageBold(_ref) {
  var message = _ref.message;
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(React.Fragment, null, intl.formatMessage(message, {
    strong: function strong(str) {
      return /*#__PURE__*/React.createElement(Text, {
        as: "strong"
      }, str);
    }
  }));
};